var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"back",class:{dark: _vm.$store.state.settings.darkMode}},[_c('img',{attrs:{"src":require("@/assets/angle.svg")}}),_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.to.name))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }